// src/pages/ImageGridPage.jsx
import React, { useEffect, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import IMG1 from "../assets/img/spelling-games.png";
import IMG4 from "../assets/img/spelltw.png";
import IMG2 from "../assets/img/typefast.png";
import IMG3 from "../assets/img/spellcheck.jpg";
import "./PuzzlePage.css";

const originalBookData = [
  { id: "Spelling Game", title: "Spelling Game", images: [IMG1] },
  { id: "Spell the Word", title: "Word Search", images: [IMG4] },
  { id: "Spell Check", title: "Spell Check", images: [IMG3] },
  { id: "Type Fast Words", title: "Type Fast Words", images: [IMG2] },
];

const PuzzlesPage = () => {
  const location = useLocation();
  const grade = location.state?.grade; // e.g., "Grade-6"

  useEffect(() => {
    if (grade) {
      console.log("Received Grade:", grade);
    }
  }, [grade]);

  const filteredBookData = useMemo(() => {
    if (["Grade-6", "Grade-7", "Grade-8"].includes(grade)) {
      return originalBookData.filter((item) => item.id !== "Spelling Game");
    }
    return originalBookData;
  }, [grade]);

  return (
    <div className="image-grid-container">
      <h2 className="grid-title">All Games</h2>
      <div className="image-grid">
        {filteredBookData.map((book, bookIndex) =>
          book.images.map((imgSrc, imgIndex) => (
            <Link
              to={`/games/${book.title.toLowerCase().replace(/\s+/g, "-")}`}
              key={`${bookIndex}-${imgIndex}`}
              className="image-card"
            >
              <img src={imgSrc} alt={book.title} className="grid-image" />
              <p className="image-caption">{book.id}</p>
            </Link>
          ))
        )}
      </div>
    </div>
  );
};

export default PuzzlesPage;
